export const APP_VARIANT_STORAGE_KEY = 'upgraded_app_variant';

export function getStoredAppVariant() {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(APP_VARIANT_STORAGE_KEY);
    return value === 'classic' || value === 'new' ? value : null;
  } catch {
    return null;
  }
}

export function setStoredAppVariant(variant) {
  if (typeof window === 'undefined') return;
  try {
    if (variant === 'classic' || variant === 'new') {
      window.localStorage.setItem(APP_VARIANT_STORAGE_KEY, variant);
    } else {
      window.localStorage.removeItem(APP_VARIANT_STORAGE_KEY);
    }
  } catch {
    // ignore quota / private mode
  }
}
